import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/GlobalProvider';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { GlobalData } from '../../assets/data/GlobalData';
import { Dashboard_Profile } from "../../assets/data/Imagedata";

const Signin = () => {
  const navigate = useNavigate();
  const { signIn, user } = useAuth(); // Destructure user from useAuth
  const [emailAddress, setEmailAddress] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  // Redirect to dashboard if user is already logged in
  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  const onSignInPress = async () => {
    setError("");

    // Validate email or phone number format
    const isValidEmail = /\S+@\S+\.\S+/.test(emailAddress);
    const isValidPhone = /^[0-9]{10}$/.test(emailAddress);
    const isValidCustomPhone = /^[A-Za-z0-9]+$/.test(emailAddress);

    if (!isValidEmail && !isValidPhone && !isValidCustomPhone) {
      setError("Please enter a valid email address or phone number.");
      return;
    }

    // Call the signIn function
    const result = await signIn(emailAddress, password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.message);
    }
  };

  return (
    <section className="flex  items-center justify-center bg-primary-100 min-h-screen text-white">
      <div className="flex flex-col items-center justify-center py-10">
        <div className="w-full max-w-md bg-primary p-8 rounded-lg shadow-md">
        <img
            src={Dashboard_Profile}
            alt="Dashboard Profile"
            className="w-20 h-20 rounded-full drop-shadow-md mx-auto"
          />
          <h1 className="text-2xl font-hearthway text-[30px] text-center">{GlobalData.company.companyName}</h1>
                    <h2 className="text-[14px] text-secondary font-bold text-center mb-4"> {GlobalData.company.companyTagLine}</h2>
          <h2 className="text-xl font-bold text-center mb-6">Log In</h2>

          <label className="text-ml">Email or Phone Number</label>
          <input
            type="text"
            value={emailAddress}
            placeholder="Email or Phone Number"
            onChange={(e) => setEmailAddress(e.target.value)}
            className="border-b border-gray-300 py-2 text-base text-black mb-4 w-full px-2 rounded-xl"
          />

          <label className="text-ml">Password</label>
          <div className="relative mb-6 w-full">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
              className="border-b border-gray-300 py-2 text-base text-black w-full px-2 rounded-xl"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 text-gray-500 px-2"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          {error && <p className="text-sm text-red-500 mb-4 text-center">{error}</p>}
          <p className="text-xs text-center m-4">
            ✓ Please read the following <span className="text-yellow-500 cursor-pointer" onClick={() => navigate('/termsconditions')}>Terms & Conditions</span>
          </p>

          <button onClick={onSignInPress} className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 mb-6 w-full rounded-full">Log In</button>
          <p className="text-sm text-center ">Don't have an account? <Link to='/signup' className="text-secondary font-bold">Sign Up</Link></p>
         
        </div>
      </div>
    </section>
  );
};

export default Signin;
